import { render, staticRenderFns } from "./coll.vue?vue&type=template&id=50ce07d9&scoped=true&"
import script from "./coll.vue?vue&type=script&lang=js&"
export * from "./coll.vue?vue&type=script&lang=js&"
import style0 from "./coll.vue?vue&type=style&index=0&id=50ce07d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce07d9",
  null
  
)

export default component.exports